import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingMumbai from "../components/blogs/DigitalMarketingMumbai";

const DigitalMarketingAgencyMumbai = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Agency in Mumbai | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Looking for a digital marketing agency in Mumbai? SMS ZOO ZOO helps businesses drive quality leads, boost visibility, and grow sales online."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-mumbai"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingMumbai />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyMumbai;
